import {
  BIKE_SCAN_TRIGGER_LOADING,
  BIKE_SCAN_TRIGGER_ERROR,
  BIKE_SCAN_TRIGGER_ADD,
  BIKE_SCAN_TRIGGER_UPDATE,
  BIKE_SCAN_TRIGGER_DELETE,
  BIKE_SCAN_TRIGGER_ACTIONS,
  // BIKE_SCAN_TRIGGER_COUNT,
  BIKE_SCAN_TRIGGER_FILTERS,
  // BIKE_SCAN_TRIGGER_FILTERS_V2,
  // BIKE_SCAN_TRIGGER_LIST,
  BIKE_SCAN_TRIGGER_SEARCH,
  BIKE_SCAN_TRIGGER_SINGLE
} from "actions/bike-scan-trigger/constants";

const initialState = {
  loading: false,
  errors: [],

  list: {},
  filters: [],
  actions: [],
  single: {}
};

export default function (state = initialState, action) {
  let list = [],
    index;

  switch (action.type) {
    case BIKE_SCAN_TRIGGER_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case BIKE_SCAN_TRIGGER_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };

    case BIKE_SCAN_TRIGGER_ADD:
      list = Object.assign({}, state.list);
      list.content = Object.assign([], list.content);
      list.content.push(action.payload);
      return {
        ...state,
        loading: false,
        list
      };
    case BIKE_SCAN_TRIGGER_UPDATE:
      list = Object.assign({}, state.list);
      list.content = Object.assign([], list.content);
      index = list.content.findIndex(item => item.id === action.payload.id);
      if (index > -1) {
        list.content[index] = action.payload;
      } else {
        list.content.push(action.payload);
      }
      return {
        ...state,
        loading: false,
        list
      };
    case BIKE_SCAN_TRIGGER_DELETE:
      list = Object.assign({}, state.list);
      list.content = Object.assign([], list.content);
      index = list.content.findIndex(item => item.id === action.payload.id);
      if (index > -1) {
        list.content.splice(index, 1);
      }
      return {
        ...state,
        loading: false,
        list
      };
    case BIKE_SCAN_TRIGGER_ACTIONS:
      return {
        ...state,
        actions: action.payload
      };
    case BIKE_SCAN_TRIGGER_FILTERS:
      return {
        ...state,
        filters: action.payload.content
      };
    case BIKE_SCAN_TRIGGER_SEARCH:
      return {
        ...state,
        loading: false,
        list: action.payload
      };
    case BIKE_SCAN_TRIGGER_SINGLE:
      return {
        ...state,
        loading: false,
        single: action.payload.content.content && Array.isArray(action.payload.content) && action.payload.content[0]
          ? action.payload.content[0]
          : {}
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/bikeScanTriggerReducer.js